export default function GradientLine() {
  return (
    <svg
      width="52"
      height="2"
      viewBox="0 0 52 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Gradient Line</title>
      <line
        x1="1"
        y1="1"
        x2="51"
        y2="1"
        stroke="url(#paint0_linear_1619_32)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1619_32"
          x1="-1.78445e-09"
          y1="2"
          x2="49.1365"
          y2="13.8617"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#96FF43" stopOpacity="0" />
          <stop offset="0.484281" stopColor="#96FF43" />
          <stop offset="1" stopColor="#96FF43" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
